// Canonical business data. Sources and launch checks: docs/CONTENT.md.
export const business = {
  name: "Imperial Cars",
  fullName: "Imperial Cars A&F",
  legalName: "Imperial Cars A&F SRL",
  phone: { display: "0743 766 518", tel: "+40743766518" },
  whatsapp: {
    number: "40743766518",
    prefill: "Bună ziua! Aș dori o programare pentru mașina mea.",
  },
  address: {
    street: "Strada Barajului nr. 9",
    city: "Târgu Mureș",
    county: "Mureș",
    country: "România",
    full: "Strada Barajului nr. 9, Târgu Mureș",
    coords: { lat: 46.5433027, lng: 24.5349203 },
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Imperial+Cars+A%26F+Targu+Mures",
    directionsUrl:
      "https://www.google.com/maps/dir/?api=1&destination=46.5433027,24.5349203",
    embedUrl:
      "https://maps.google.com/maps?q=Imperial%20Cars%20A%26F%20SRL%2C%20Strada%20Barajului%209%2C%20Targu%20Mures&ll=46.5433027,24.5349203&z=17&output=embed",
  },
  hours: {
    confirmed: false,
    display: "Sună pentru program și disponibilitate.",
  },
  images: {
    hero: "/images/brake-editorial.webp",
    workshop: "/images/tools.jpg",
    original: {
      hero: "/images/original/diagnostic-real.webp",
      detail: "/images/original/gears-real.webp",
      workshop: "/images/original/engine-bench-real.webp",
      service: "/images/original/cylinder-head-real.webp",
      contact: "/images/original/transmission-real.webp",
    },
  },
  seo: {
    siteName: "Imperial Cars A&F",
    defaultTitle: "Imperial Cars A&F · Service auto în Târgu Mureș",
    defaultDescription:
      "Diagnosticare, reparații mecanice și electrice, revizii auto pe Strada Barajului nr. 9, Târgu Mureș. Contactează Imperial Cars A&F pentru o programare.",
    keywords:
      "service auto Târgu Mureș, Imperial Cars, diagnosticare, mecanică, frâne",
    ogImage: "/images/engine-blender.webp",
    baseUrl: process.env.REACT_APP_SITE_URL || "",
  },
  services: [
    {
      slug: "diagnosticare-auto",
      title: "Diagnosticare și inspecție",
      group: "Diagnosticare",
      short:
        "Citirea erorilor, inspecție și măsurători pentru identificarea defecțiunilor.",
      symptoms: [
        "Martori aprinși în bord",
        "Pierdere de putere",
        "Pornire dificilă",
        "Zgomote sau vibrații",
      ],
      note: "Menționează martorii aprinși în bord și condițiile în care apare problema.",
    },
    {
      slug: "sistem-de-franare",
      title: "Sistem de frânare",
      group: "Reparații",
      short:
        "Verificarea discurilor, plăcuțelor, etrierelor și lichidului de frână. Înlocuirea componentelor uzate, în funcție de constatare.",
      symptoms: [
        "Vibrații la frânare",
        "Zgomote la apăsarea pedalei",
        "Frânare neuniformă",
      ],
      note: "Descrie când apare problema: la viteză mică, după încălzire sau la o frânare mai puternică.",
    },
    {
      slug: "suspensie-directie",
      title: "Suspensie și direcție",
      group: "Reparații",
      short:
        "Verificarea și repararea articulațiilor, amortizoarelor și componentelor direcției.",
      symptoms: [
        "Bătăi pe denivelări",
        "Joc în volan",
        "Uzură neuniformă a anvelopelor",
      ],
      note: "Spune-ne din ce zonă se aude zgomotul și dacă apare în viraje sau pe drum denivelat.",
    },
    {
      slug: "motor-sisteme-auxiliare",
      title: "Motor și sisteme auxiliare",
      group: "Reparații",
      short:
        "Diagnosticarea și repararea defecțiunilor motorului și ale sistemelor auxiliare.",
      symptoms: [
        "Funcționare neregulată",
        "Consum crescut",
        "Zgomote din compartimentul motor",
      ],
      note: "Menționează motorizarea, kilometrajul și eventualele reparații recente.",
    },
    {
      slug: "transmisie-ambreiaj",
      title: "Transmisie și ambreiaj",
      group: "Reparații",
      short:
        "Verificarea transmisiei și ambreiajului. Reparații în funcție de defecțiunea constatată.",
      symptoms: [
        "Schimbare dificilă a treptelor",
        "Ambreiaj care patinează",
        "Vibrații la plecare",
      ],
      note: "Menționează dacă simptomele apar cu motorul rece, la cald sau în anumite trepte.",
    },
    {
      slug: "mecanica-generala",
      title: "Mecanică generală",
      group: "Reparații",
      short:
        "Constatarea defecțiunilor și înlocuirea componentelor mecanice uzate sau defecte.",
      symptoms: [
        "Componente uzate",
        "Zgomote la rulare",
        "Funcționare neuniformă",
      ],
      note: "Disponibilitatea intervenției se confirmă în funcție de marcă, model și problemă.",
    },
    {
      slug: "electricitate-auto",
      title: "Electricitate auto",
      group: "Reparații",
      short: "Diagnosticarea și repararea defecțiunilor electrice ale mașinii.",
      symptoms: [
        "Probleme de pornire",
        "Defecțiuni la sistemul de încărcare",
        "Echipamente electrice nefuncționale",
      ],
      note: "Menționează echipamentul afectat și dacă problema apare permanent sau intermitent.",
    },
    {
      slug: "intretinere-periodica",
      title: "Revizii și întreținere",
      group: "Întreținere",
      short:
        "Schimb de ulei și filtre, verificarea lichidelor și a pieselor de uzură, conform cerințelor de întreținere ale mașinii.",
      symptoms: [
        "Schimb de ulei și filtre",
        "Verificarea lichidelor",
        "Întreținere periodică",
      ],
      note: "Menționează kilometrajul și data ultimei revizii, dacă sunt cunoscute.",
    },
  ],
};
export const routes = {
  home: "/",
  services: "/servicii",
  about: "/despre-noi",
  process: "/procesul-de-lucru",
  faq: "/intrebari-frecvente",
  contact: "/contact",
  privacy: "/politica-de-confidentialitate",
  cookies: "/politica-de-cookies",
};
export const nav = [
  { label: "Servicii", to: "/#servicii" },
  { label: "Cum lucrăm", to: "/#despre-service" },
  { label: "Contact", to: "/#contact" },
];
export const telHref = () => "tel:" + business.phone.tel;
export const whatsappHref = (message = business.whatsapp.prefill) =>
  "https://wa.me/" +
  business.whatsapp.number +
  "?text=" +
  encodeURIComponent(message);
